import { LOCATION_INDIA, tierNames } from "Constants";
import { useUserLocation } from "GlobalStates/Location";

export const featureIcons = {
  "College Guidance Tools": "🎓",
  "AI & Personalization": "🤖",
  "Community & Support": "👥",
  "Finance & Scholarships": "💸",
};

export const usePlans = () => {
  const { location } = useUserLocation();

  const plans = [
    {
      name: tierNames.STARTER,
      subtitle: "Begin your global education journey",
      price: "Free",
      subtag: "forever",
      undertag: "",
      originalPrice: null,
      cta: "Start Free",
      highlight: false,
      features: {
        "College Guidance Tools": [
          "5 college recommendations",
          "College readiness score",
        ],
        "AI & Personalization": ["Apply for OG Finance", "Basic AI score"],
        "Community & Support": ["Access public community"],
        "Finance & Scholarships": [
          "Free loan consultation",
          "Apply for OG Finance",
        ],
      },
    },
    {
      name: tierNames.ACHIEVER,
      subtitle: "Maximize your admission chances",
      price: location === LOCATION_INDIA ? "₹9,999" : "$99",
      originalPrice: location === LOCATION_INDIA ? "₹19,999" : "$249",
      subtag: "/year",
      undertag: "$0 with OneGrad Finance",
      cta: "Unlock Success",
      highlight: true,
      badgeText: "82% of OneGrad Achievers landed admits in top 3 choices",
      features: {
        "College Guidance Tools": [
          "Unlimited research tools",
          "Guided SoP & LoR builder",
          "Everything in Starter",
        ],
        "AI & Personalization": [
          "50,000 AI credits",
          "Personalized college matching",
          "Ask-AI college assistant (24/7)",
        ],
        "Community & Support": [
          "Access to OG Community",
          "15-min 1-1 consultation (based on availability)",
        ],
        "Finance & Scholarships": [
          "Eligible for $1000 OG Scholarship",
          "Membership refund on OG finance approval",
        ],
      },
    },
    {
      name: tierNames.MENTORED,
      subtitle: "Premium 1-on-1 guidance",
      price: location === LOCATION_INDIA ? "₹19,999" : "$249",
      originalPrice: location === LOCATION_INDIA ? "₹39,999" : "$499",
      // subtag: "/year",
      cta: "Get Mentored",
      undertag: "$0 with OneGrad Finance",
      highlight: false,
      badgeText: "3 advisor sessions included for personalized college plan",
      features: {
        "College Guidance Tools": [
          "Everything in Achiever",
          "Dedicated 1-on-1 admission advisor (3 sessions included)",
        ],
        "AI & Personalization": [
          "100,000 AI credits",
          "Advisor-assisted AI tools",
        ],
        "Community & Support": [
          "Private mentor community access",
          "Advisor-led chat",
        ],
        "Finance & Scholarships": [
          "Scholarship review with advisor",
          "Pro-level finance guidance",
        ],
      },
    },
  ];

  return plans;
};
